'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleFunctionOnLazyInterval = scheduleFunctionOnLazyInterval;
var MIN_POLL_INTERVAL = 1000;
var hasRequestIdleCallback = window.requestIdleCallback;

var lazyCheck = hasRequestIdleCallback ? function (func) {
  return requestIdleCallback(func);
} : function (func) {
  return func();
};

function scheduleFunctionOnLazyInterval(jobFunc, timeout) {
  var timeoutId = void 0,
      idleId = void 0;

  var wrappedFunc = function wrappedFunc() {
    idleId = lazyCheck(function () {
      jobFunc();
      timeoutId = setTimeout(wrappedFunc, timeout);
    });
  };

  timeoutId = setTimeout(wrappedFunc, timeout);

  // Return a cancel function
  return function () {
    clearTimeout(timeoutId);

    if (idleId && window.cancelIdleCallback) {
      window.cancelIdleCallback(idleId);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.22/js/util/schedule.js
// module id = 245
// module chunks = 0